import "isomorphic-fetch";
import { Aurelia, PLATFORM, LogManager  } from "aurelia-framework";
import { HttpClient } from "aurelia-fetch-client";
import "materialize-css";
import { Backend, TCustomAttribute } from "aurelia-i18n";
import { ApplicationUser } from "./app/components/models/application-user";
import { initialState } from "./app/components/store/state";

// ReSharper disable once InconsistentNaming
declare const IS_DEV_BUILD: boolean; // The value is supplied by Webpack during the build

export async function configure(aurelia: Aurelia) {
	await aurelia.loader.loadModule(PLATFORM.moduleName("materialize-css"));

	const httpClient = new HttpClient().configure((config: any) => {
		config.useStandardConfiguration();
		config.withBaseUrl(`${window.location.origin}/`);
		config.withDefaults({
			credentials: "same-origin"
		});
		config.withInterceptor({
			response(response) {
				return response;
			},
			responseError(error: any) {
				return error;
			}
		});
	});

	const container = aurelia.container;
	container.registerInstance(HttpClient, httpClient);

	// setup aurelia-store initial state
	const applicationUser: ApplicationUser = new ApplicationUser();
	applicationUser.init((window as any).applicationUser as ApplicationUser);
	aurelia.container.registerInstance(ApplicationUser, applicationUser);
	initialState.applicationUser = Object.assign({}, applicationUser);

	aurelia.use
		.standardConfiguration()
		.feature(PLATFORM.moduleName("app/components/controls/index"))
		.feature(PLATFORM.moduleName("app/components/attributes/index"))
		.feature(PLATFORM.moduleName("app/components/converters/index"))
		.feature(PLATFORM.moduleName("app/components/aurelia-chart/index"))
		.feature(PLATFORM.moduleName("app/components/aurelia-tree-view/index"))
		// .feature(PLATFORM.moduleName("app/components/models/index"))
		// .globalResources("")

		.plugin(PLATFORM.moduleName("aurelia-async-binding"))
		.plugin(PLATFORM.moduleName("aurelia-materialize-bridge"), b => b.useAll())
		.plugin(PLATFORM.moduleName("aurelia-store"), { initialState })
		.plugin(PLATFORM.moduleName("aurelia-dialog"))
		.plugin(PLATFORM.moduleName("aurelia-dynamic-html"))
		.plugin(PLATFORM.moduleName("aurelia-resize"))
		.plugin(PLATFORM.moduleName("aurelia-validation"))
		.plugin(PLATFORM.moduleName("aurelia-i18n"),
			(instance) => {
				const aliases = ["t", "i18n"];
				// add aliases for 't' attribute
				TCustomAttribute.configureAliases(aliases);

				// register backend plugin
				instance.i18next.use(Backend.with(aurelia.loader));

				let language = localStorage.getItem("user-language");
				if (!language) {
					language = "en";
				}

				// adapt options to your needs (see http://i18next.com/docs/options/)
				// make sure to return the promise of the setup method, in order to guarantee proper loading
				return instance.setup({
					backend: { loadPath: "locales/{{lng}}/{{ns}}.json" },
					attributes: aliases,
					lng: language,
					fallbackLng: "en",
					debug: true
				});
			});

	if (IS_DEV_BUILD) {
		aurelia.use.developmentLogging();
	}

	aurelia.start().then(() => { aurelia.setRoot("app/components/app/app"); });
}
